import { ApolloClient, InMemoryCache, Resolvers, useApolloClient } from '@apollo/client';
import * as React from 'react';

/**
 * Type to use for mutation on local apollo state, to save re-defining the same type each time.
 */
export type InMemoryResolver<T> = (
  rootValue: any,
  args: T,
  context: { cache: InMemoryCache }
) => void;

/**
 * Helper function to add a resolver once within a components lifecycle.
 *
 * @param resolvers resolvers to add to client
 */
export const useResolvers: (resolvers: Resolvers | Resolvers[]) => void = resolvers => {
  const client: ApolloClient<{}> = useApolloClient();
  React.useMemo(() => {
    client.addResolvers(resolvers);
  }, [client]);
};
